/* eslint-disable */
<template lang="html">
  <div style="margin-bottom: 300px">
    <div
      class="display-1 
                d-flex 
                justify-center 
                mt-12
                pt-4
                grey--text 
                text--darken-2
                "
      v-text="name"
    ></div>
    <v-container class="my-5">
      <v-layout row>
        <template v-for="(product, i) in products">
          <v-col :key="i" cols="12" md="4">
            <v-hover v-slot:default="{ hover }">
              <v-card
                class="mx-auto 
                  mb-4
                  mt-2"
                max-width="344"
                min-height="300"
                :elevation="hover ? 12 : 2"
              >
                <v-hover v-slot:default="{ hover }">
                  <router-link :to="product.prodLink" :event="product.clicking">
                    <v-img
                      v-bind:src="product.prodImgUrl"
                      :lazy-src="lazyImg"
                      height="200px"
                    ></v-img>

                    <v-card-title
                      style="word-break: normal;"
                      class="text-center"
                    >
                      <span style="margin: 0 auto" v-text="product.prodName">
                      </span>
                    </v-card-title>
                  </router-link>
                </v-hover>
              </v-card>
            </v-hover>
          </v-col>
        </template>
        <!-- ssss -->
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  data: () => ({
    name: "SASH პროდუქცია",
    text: "This is sash product",
    show: false,
    alignmentsAvailable: ["start", "center", "end", "baseline", "stretch"],
    alignment: "center",
    dense: false,
    justifyAvailable: [
      "start",
      "center",
      "end",
      "space-around",
      "space-between"
    ],
    justify: "center",
    lazyImg: require("@/assets/lazy_engine_oil.png"),
    products: [
      {
        prodName: "სამგზავრო მანქანის ძრავის ზეთები",
        prodImgUrl:
          "https://i1.wp.com/www.lubricantes-sash.com/wp-content/uploads/2017/12/TURISMO-1.jpg?zoom=1.25&w=930&ssl=1",
        prodLink: "/sashpasscarengoil",
        clicking: "click"
      },
      {
        prodName: "სატვირთო მანქანის ძრავის ზეთები",
        prodImgUrl:
          "https://i2.wp.com/www.lubricantes-sash.com/wp-content/uploads/2017/12/CAMION.jpg?zoom=1.25&w=930&ssl=1",
        prodLink: "/sashhavyduty",
        clicking: "click"
      },
      {
        prodName: "მოტოციკლეტის ლუბრიკანტები",
        prodImgUrl:
          "https://i0.wp.com/www.lubricantes-sash.com/wp-content/uploads/2017/12/MOTO.jpg?zoom=1.25&w=930&ssl=1",
        prodLink: "/sashmotorcykle",
        clicking: "click"
      },
      {
        prodName: "აგროკულტურული ლუბრიკანტები",
        prodImgUrl:
          "https://i0.wp.com/www.lubricantes-sash.com/wp-content/uploads/2017/12/AGRICULTURA.jpg?zoom=1.25&w=930&ssl=1",
        prodLink: "/sashagrocultural",
        clicking: "none"
      },
      {
        prodName: "ტრანსმისიის საზეთი საშუალებები",
        prodImgUrl:
          "https://i0.wp.com/www.lubricantes-sash.com/wp-content/uploads/2017/12/TRANSMISIONES.jpg?zoom=1.25&w=930&ssl=1",
        prodLink: "/sashtransmissions",
        clicking: "click"
      },
      {
        prodName: "საზღვაო საზეთი საშუალებები",
        prodImgUrl:
          "https://i1.wp.com/www.lubricantes-sash.com/wp-content/uploads/2017/12/MARINO.jpg?zoom=1.25&w=930&ssl=1",
        prodLink: "/sashmarine",
        clicking: "none"
      },
      {
        prodName: "საპოხი საშუალებები",
        prodImgUrl:
          "https://i1.wp.com/www.lubricantes-sash.com/wp-content/uploads/2017/12/GRASAS.jpg?zoom=1.25&w=930&ssl=1",
        prodLink: "/sashgreases",
        clicking: "none"
      },
      {
        prodName: "ინდუსტრიული საზეთი საშუალებები",
        prodImgUrl:
          "https://i1.wp.com/www.lubricantes-sash.com/wp-content/uploads/2017/12/INDUSTRIAL.jpg?zoom=1.25&w=930&ssl=1",
        prodLink: "/sashindustrial",
        clicking: "click"
      },
      {
        prodName: "გარე გამოყენების მასალები",
        prodImgUrl:
          "https://i1.wp.com/www.lubricantes-sash.com/wp-content/uploads/2017/12/AUXILIARES-1.jpg?zoom=1.25&w=930&ssl=1",
        prodLink: "/sashauxilary",
        clicking: "none"
      }
    ]
  })
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
